const base = {
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.8,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};

export const HomeIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M3 11.5 12 4l9 7.5" />
    <path d="M5.5 10v9a1 1 0 0 0 1 1H10v-6h4v6h3.5a1 1 0 0 0 1-1v-9" />
  </svg>
);

export const UsersIcon = (p) => (
  <svg {...base} {...p}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3.5 20c0-3.3 2.5-5.5 5.5-5.5s5.5 2.2 5.5 5.5" />
    <circle cx="17" cy="8.5" r="2.4" />
    <path d="M15.5 14.7c2.4.4 4 2.3 4 5.3" />
  </svg>
);

export const ReceiptIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M6 3h12v18l-2.5-1.6L13 21l-1.5-1.6L10 21l-1.5-1.6L6 21Z" />
    <path d="M9 8h6M9 12h6M9 16h3.5" />
  </svg>
);

export const WalletIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M3.5 7.5A2.5 2.5 0 0 1 6 5h12a1.5 1.5 0 0 1 1.5 1.5V8" />
    <rect x="3.5" y="8" width="17" height="12" rx="2" />
    <path d="M15 14a1.4 1.4 0 1 0 0 .01Z" />
  </svg>
);

export const AlertIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M12 3.5 2.5 20h19Z" />
    <path d="M12 9.5v4.2" />
    <path d="M12 17.2h.01" />
  </svg>
);

export const ShieldIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M12 3.5 5 6v6c0 4.6 3 7.7 7 8.5 4-.8 7-3.9 7-8.5V6Z" />
    <path d="m9 12 2 2 4-4.2" />
  </svg>
);

export const ChevronRightIcon = (p) => (
  <svg {...base} {...p}>
    <path d="m9 5 7 7-7 7" />
  </svg>
);

export const SunIcon = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="4.2" />
    <path d="M12 2.5v2.2M12 19.3v2.2M4.6 4.6l1.55 1.55M17.85 17.85 19.4 19.4M2.5 12h2.2M19.3 12h2.2M4.6 19.4l1.55-1.55M17.85 6.15 19.4 4.6" />
  </svg>
);

export const MoonIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M20 14.2A8.2 8.2 0 1 1 9.8 4a6.4 6.4 0 0 0 10.2 10.2Z" />
  </svg>
);

export const MenuIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

export const CloseIcon = (p) => (
  <svg {...base} {...p}>
    <path d="m6 6 12 12M18 6 6 18" />
  </svg>
);

export const SearchIcon = (p) => (
  <svg {...base} {...p}>
    <circle cx="11" cy="11" r="7" />
    <path d="m20.5 20.5-4-4" />
  </svg>
);

export const LogoMarkIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M12 3.5 4.5 7.5v9L12 20.5l7.5-4v-9Z" />
    <path d="M8 10.2 12 8l4 2.2v4.6L12 17l-4-2.2Z" />
  </svg>
);

export const LoopMarkIcon = (p) => (
  <svg {...base} {...p} viewBox="0 0 24 24">
    <path d="M8 16c-2.8 0-5-2.2-5-5s2.2-5 5-5c2.4 0 4.4 1.7 4.9 4 .5-2.3 2.5-4 4.9-4 2.8 0 5 2.2 5 5s-2.2 5-5 5c-2.4 0-4.4-1.7-4.9-4-.5 2.3-2.5 4-4.9 4Z" />
  </svg>
);

// High-fidelity StuCred Collegiate Varsity "S" Logo with 3D bevels & orange trim
export const StucredLogoIcon = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    style={{ display: "block" }}
  >
    {/* 3D Offset Bevel Shadow Lines */}
    <path
      d="M38 12H68L86 30V44L74 52L86 64V76L70 92H42"
      stroke="#1e3a8a"
      strokeWidth="5"
      strokeLinejoin="bevel"
    />
    <path
      d="M40 10H70L90 30V44L78 52L90 64V78L70 98H38"
      stroke="#ea580c"
      strokeWidth="3.5"
      strokeLinejoin="bevel"
    />

    {/* Outer Orange Border Frame */}
    <path
      d="M34 14H66L82 30V42L70 50L82 62V74L66 90H34L18 74V60H34V70L40 76H60L66 70V62L56 54H34L18 40V26L34 14Z"
      fill="#ff5900"
    />

    {/* Solid Royal Blue "S" Body */}
    <path
      d="M36 17H64L79 32V41L68 49L46 49V43H63L65 39V35L59 29H39L35 34V41L45 51H63L79 63V73L64 87H36L21 73V62H35V69L41 74H59L65 69V63L55 55H35L21 41V27L36 17Z"
      fill="#0038e0"
    />

    {/* Inner Orange Contour Line inside Blue S */}
    <path
      d="M38 21H62L74 33V39L65 46H44V41H62L63 38V36L58 31H40L37 35V40L46 49H61L74 59V71L62 83H38L25 71V63H33V67L39 72H57L63 67V63L53 55H37L25 43V29L38 21Z"
      stroke="#ff6a00"
      strokeWidth="1.6"
      fill="none"
    />
  </svg>
);

export const TrendUpIcon = (p) => (
  <svg {...base} {...p}>
    <path d="m4 16 5.5-6.5L13 13l7-8" />
    <path d="M15.5 5H20v4.5" />
  </svg>
);

export const TrendDownIcon = (p) => (
  <svg {...base} {...p}>
    <path d="m4 8 5.5 6.5L13 11l7 8" />
    <path d="M15.5 19H20v-4.5" />
  </svg>
);

export const ErrorIcon = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7.5v6" />
    <path d="M12 16.7h.01" />
  </svg>
);

export const RefreshIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M4 12a8 8 0 0 1 13.66-5.66L20 8.5" />
    <path d="M20 4v4.5h-4.5" />
    <path d="M20 12a8 8 0 0 1-13.66 5.66L4 15.5" />
    <path d="M4 20v-4.5h4.5" />
  </svg>
);

export const SparklesIcon = (p) => (
  <svg {...base} {...p}>
    <path d="m12 3-1.9 5.8L4.3 10.7l5.8 1.9L12 18.4l1.9-5.8 5.8-1.9-5.8-1.9L12 3Z" />
    <path d="M19 16l-.8 2.2-2.2.8 2.2.8.8 2.2.8-2.2 2.2-.8-2.2-.8L19 16Z" />
  </svg>
);

export const SlidersIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M4 21v-7M4 10V3M12 21v-9M12 8V3M20 21v-5M20 12V3M1 14h6M9 8h6M17 16h6" />
  </svg>
);

export const ClockIcon = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 7v5l3 2" />
  </svg>
);

export const FileTextIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="16" y1="13" x2="8" y2="13" />
    <line x1="16" y1="17" x2="8" y2="17" />
    <polyline points="10 9 9 9 8 9" />
  </svg>
);

export const PaperclipIcon = (p) => (
  <svg {...base} {...p}>
    <path d="m21.44 11.05-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48" />
  </svg>
);

export const SendIcon = (p) => (
  <svg {...base} {...p}>
    <line x1="22" y1="2" x2="11" y2="13" />
    <polygon points="22 2 15 22 11 13 2 9 22 2" />
  </svg>
);

export const BellIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
    <path d="M13.73 21a2 2 0 0 1-3.46 0" />
  </svg>
);

export const SettingsIcon = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

export const StarIcon = (p) => (
  <svg {...base} {...p}>
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
  </svg>
);

export const MoreHorizontalIcon = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="1.2" />
    <circle cx="19" cy="12" r="1.2" />
    <circle cx="5" cy="12" r="1.2" />
  </svg>
);

export const ShareIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8" />
    <polyline points="16 6 12 2 8 6" />
    <line x1="12" y1="2" x2="12" y2="15" />
  </svg>
);

export const CheckCircleIcon = (p) => (
  <svg {...base} {...p}>
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

export const FilterIcon = (p) => (
  <svg {...base} {...p}>
    <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
  </svg>
);

export const InfoIcon = (p) => (
  <svg {...base} {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5.5" />
    <path d="M12 7.7h.01" />
  </svg>
);

export const ArrowUpRightIcon = (p) => (
  <svg {...base} {...p}>
    <line x1="7" y1="17" x2="17" y2="7" />
    <polyline points="7 7 17 7 17 17" />
  </svg>
);
